// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad = require("../Control.Monad/index.js");
var Control_Monad_Maybe_Trans = require("../Control.Monad.Maybe.Trans/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either_Extra = require("../Data.Either.Extra/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Money_Rounded = require("../Data.Money.Rounded/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Number = require("../Data.Number/index.js");
var Data_Numeric = require("../Data.Numeric/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Record = require("../Data.Record/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_String_Regex = require("../Data.String.Regex/index.js");
var Data_String_Regex_Flags = require("../Data.String.Regex.Flags/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Data_Validation_Semigroup = require("../Data.Validation.Semigroup/index.js");
var Partial_Unsafe = require("../Partial.Unsafe/index.js");
var Specular_Callback = require("../Specular.Callback/index.js");
var Specular_FRP_Base = require("../Specular.FRP.Base/index.js");
var Specular_Ref = require("../Specular.Ref/index.js");
var Final = function (x) {
    return x;
};
var FormField = (function () {
    function FormField(value0) {
        this.value0 = value0;
    };
    FormField.create = function (value0) {
        return new FormField(value0);
    };
    return FormField;
})();
var Conversion = function (x) {
    return x;
};
var unFinal = function (v) {
    return v;
};
var semigroupoidConversion = new Control_Semigroupoid.Semigroupoid(function (v) {
    return function (v1) {
        return {
            fromInitial: function ($150) {
                return v.fromInitial(v1.fromInitial($150));
            },
            toFinal: (function () {
                var $151 = Data_Validation_Semigroup.unV(Data_Validation_Semigroup.invalid)(v1.toFinal);
                return function ($152) {
                    return $151(v.toFinal($152));
                };
            })()
        };
    };
});
var phoneRE = Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(Data_String_Regex.regex("^\\+?[0-9 -]+$")(Data_String_Regex_Flags.noFlags));
var normalizeDecimalSeparator = function (s) {
    var $54 = Data_String_CodeUnits.contains(".")(s);
    if ($54) {
        return s;
    };
    return Data_String_Common.replace(",")(".")(s);
};
var nonNothingConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $55 = Data_Maybe.isNothing(x);
            if ($55) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var nonEmptyStringConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $56 = Data_String_Common["null"](Data_String_Common.trim(x));
            if ($56) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var nonEmptyArrayConversion = function (errorMessage) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $57 = Data_Foldable["null"](Data_Foldable.foldableArray)(x);
            if ($57) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var noFieldState = {
    submitOccured: Specular_FRP_Base.never,
    remoteErrors: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Monoid.mempty(Data_Monoid.monoidArray))
};
var newFormFieldEDyn = function (dictMonadFRP) {
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Ref.newRef(dictMonadFRP.MonadEffect0())(initial))(function (ref) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Callback.newCallback(dictMonadFRP.MonadEffect0()))(function (focusOutCallback1) {
                        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(dictMonadFRP)(false)(Specular_FRP_Base.leftmost([ Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(focusOutCallback1.event), Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(remoteState.submitOccured) ])))(function (isTouched1) {
                            var toFinal = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                                return v.toFinal;
                            })(conversion);
                            return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(new FormField({
                                editRef: ref,
                                focusOutCallback: focusOutCallback1.callback,
                                finalValue: Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Function.apply)(toFinal))(Specular_Ref.refValue(ref)),
                                isTouched: isTouched1,
                                remoteState: remoteState
                            }));
                        });
                    });
                });
            };
        };
    };
};
var newFormFieldE = function (dictMonadFRP) {
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldEDyn(dictMonadFRP)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(conversion))(remoteState)(initial);
            };
        };
    };
};
var newFormField = function (dictMonadFRP) {
    return function (v) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldE(dictMonadFRP)(v)(remoteState)(v.fromInitial(initial));
            };
        };
    };
};
var moneyRE = Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]{2})?$")(Data_String_Regex_Flags.noFlags));
var maybeStringConversion = (function () {
    var toFinal = function (v) {
        if (v === "") {
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
        };
        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(v));
    };
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: toFinal
    };
})();
var maybeConversion = function (errorMessage) {
    return {
        fromInitial: Data_Maybe.Just.create,
        toFinal: function (v) {
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 323, column 9 - line 325, column 44): " + [ v.constructor.name ]);
        }
    };
};
var makeFinal = function ($153) {
    return Final(Control_Monad_Maybe_Trans.MaybeT($153));
};
var liftMaybe = (function () {
    var $154 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($155) {
        return makeFinal($154($155));
    };
})();
var liftDynamic = (function () {
    var $156 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
    return function ($157) {
        return makeFinal($156($157));
    };
})();
var isTouched = function (v) {
    return v.value0.isTouched;
};
var invalidFinal = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Maybe.Nothing.value);
var intConversion = function (errorMessage) {
    return {
        fromInitial: Data_Show.show(Data_Show.showInt),
        toFinal: function (e) {
            var v = Data_Int.fromString(e);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 382, column 9 - line 384, column 27): " + [ v.constructor.name ]);
        }
    };
};
var intPercentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $73 = x >= 0 && x <= 100;
            if ($73) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var nonNegativeIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $77 = x >= 0;
            if ($77) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeIntError ]);
        }
    });
};
var positiveIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $81 = x > 0;
            if ($81) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveIntError ]);
        }
    });
};
var rangeIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $85 = v.max >= x && x >= v.min;
            if ($85) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.rangeIntError ]);
        }
    });
};
var functorFinal = Control_Monad_Maybe_Trans.functorMaybeT(Specular_FRP_Base.functorDynamic);
var hasFieldFinal = function (dictHasField) {
    return new Data_Record.HasField(function (label) {
        return Data_Functor.map(functorFinal)(Data_Record.getField(dictHasField)(label));
    });
};
var focusOutCallback = function (v) {
    return v.value0.focusOutCallback;
};
var finalValueNoErr = function (v) {
    return Final(Control_Monad_Maybe_Trans.MaybeT(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.unV(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Maybe.Just.create))(v.value0.finalValue)));
};
var finalValue = function (v) {
    return v.value0.finalValue;
};
var fieldStateEmpty = function (formState) {
    return {
        submitOccured: formState.submitOccured,
        remoteErrors: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Monoid.mempty(Data_Monoid.monoidArray))
    };
};
var errorsFromV = function (dictMonoid) {
    return Data_Validation_Semigroup.unV(Control_Category.identity(Control_Category.categoryFn))(function (v) {
        return Data_Monoid.mempty(dictMonoid);
    });
};
var emptyConversion = function (dictMonoid) {
    return function (dictEq) {
        return function (v) {
            return {
                fromInitial: Data_Maybe.maybe(Data_Monoid.mempty(dictMonoid))(v.fromInitial),
                toFinal: function (x) {
                    var $97 = Data_Eq.eq(dictEq)(x)(Data_Monoid.mempty(dictMonoid));
                    if ($97) {
                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
                    };
                    return Data_Functor.map(Data_Validation_Semigroup.functorV)(Data_Maybe.Just.create)(v.toFinal(x));
                }
            };
        };
    };
};
var emailRE = Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(Data_String_Regex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data_String_Regex_Flags.noFlags));
var editRef = function (v) {
    return v.value0.editRef;
};
var formFieldValue = function ($158) {
    return Specular_Ref.refValue(editRef($158));
};
var doesPhoneMatchRegex = Data_String_Regex.test(phoneRE);
var maybePhoneConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $102 = Data_String_Common["null"](xt);
            if ($102) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
            };
            var $103 = doesPhoneMatchRegex(xt);
            if ($103) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var phoneConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $104 = doesPhoneMatchRegex(xt);
            if ($104) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var doesMoneyMatchRegex = Data_String_Regex.test(moneyRE);
var moneyConversion = function (errorMessage) {
    return {
        fromInitial: Data_Money_Rounded.toString,
        toFinal: function (x) {
            var v = Data_Money_Rounded.fromString(normalizeDecimalSeparator(x));
            var v1 = doesMoneyMatchRegex(x);
            if (v1 && v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeMoneyConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(moneyConversion(v.moneyError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $109 = Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney)(x)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney));
            if ($109) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeMoneyError ]);
        }
    });
};
var positiveMoneyConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(moneyConversion(v.moneyError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $113 = Data_Ord.greaterThan(Data_Money_Rounded.ordMoney)(x)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney));
            if ($113) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveMoneyError ]);
        }
    });
};
var doesEmailMatchRegex = Data_String_Regex.test(emailRE);
var emailConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $116 = doesEmailMatchRegex(xt);
            if ($116) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var maybeEmailConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $117 = Data_String_Common["null"](xt);
            if ($117) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
            };
            var $118 = doesEmailMatchRegex(xt);
            if ($118) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var displayedErrors = function (v) {
    return Control_Apply.lift3(Specular_FRP_Base.applyDynamic)(function ($$final) {
        return function (remote) {
            return function (isTouched$prime) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                    if (isTouched$prime) {
                        return errorsFromV(Data_Monoid.monoidArray)($$final);
                    };
                    return [  ];
                })())(remote);
            };
        };
    })(v.value0.finalValue)(v.value0.remoteState.remoteErrors)(v.value0.isTouched);
};
var decimalRE = Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]+)?$")(Data_String_Regex_Flags.noFlags));
var doesNumberMatchRegex = Data_String_Regex.test(decimalRE);
var numberConversion = function (errorMessage) {
    return {
        fromInitial: Data_Show.show(Data_Show.showNumber),
        toFinal: function (e) {
            var v = Data_Number.fromString(normalizeDecimalSeparator(e));
            var v1 = doesNumberMatchRegex(e);
            if (v1 && v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeNumberConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $126 = x >= 0.0;
            if ($126) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeNumError ]);
        }
    });
};
var percentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $130 = x >= 0.0 && x <= 100.0;
            if ($130) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var positiveNumberConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $134 = x > 0.0;
            if ($134) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveNumError ]);
        }
    });
};
var categoryConversion = new Control_Category.Category(function () {
    return semigroupoidConversion;
}, {
    fromInitial: Control_Category.identity(Control_Category.categoryFn),
    toFinal: Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))
});
var atPath = function (path) {
    var $159 = Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray));
    var $160 = Data_Map_Internal.lookup(Data_Ord.ordArray(Data_Ord.ordString))(path);
    return function ($161) {
        return $159($160($161));
    };
};
var fieldState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: Data_Functor.map(Specular_FRP_Base.functorDynamic)(atPath(path))(formState.remoteErrors)
        };
    };
};
var arrayStripPrefix = function (dictEq) {
    return function (prefix) {
        return function (input) {
            var $137 = Data_Eq.eq(Data_Eq.eqArray(dictEq))(Data_Array.take(Data_Array.length(prefix))(input))(prefix);
            if ($137) {
                return new Data_Maybe.Just(Data_Array.drop(Data_Array.length(prefix))(input));
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var stripPathPrefix = function (prefix) {
    var strip = function (v) {
        return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create)(arrayStripPrefix(Data_Eq.eqString)(prefix)(v.value0)))(Control_Applicative.pure(Data_Maybe.applicativeMaybe)(v.value1));
    };
    var $162 = Data_Map_Internal.fromFoldable(Data_Ord.ordArray(Data_Ord.ordString))(Data_Foldable.foldableArray);
    var $163 = Data_Array.mapMaybe(strip);
    var $164 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    return function ($165) {
        return $162($163($164($165)));
    };
};
var focusFormState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: Data_Functor.map(Specular_FRP_Base.functorDynamic)(stripPathPrefix(path))(formState.remoteErrors)
        };
    };
};
var applyFinal = new Control_Apply.Apply(function () {
    return functorFinal;
}, function (v) {
    return function (v1) {
        return Specular_FRP_Base.map2(Control_Apply.apply(Data_Maybe.applyMaybe))(v)(v1);
    };
});
var bindFinal = new Control_Bind.Bind(function () {
    return applyFinal;
}, function (v) {
    return function (k) {
        return Control_Bind.bind(Control_Monad_Maybe_Trans.bindMaybeT(Specular_FRP_Base.monadDynamic))(v)(function (x) {
            var v1 = k(x);
            return v1;
        });
    };
});
var semigroupFinal = function (dictSemigroup) {
    return new Data_Semigroup.Semigroup(Control_Apply.lift2(applyFinal)(Data_Semigroup.append(dictSemigroup)));
};
var applicativeFinal = new Control_Applicative.Applicative(function () {
    return applyFinal;
}, (function () {
    var $166 = Control_Applicative.pure(Control_Monad_Maybe_Trans.applicativeMaybeT(Specular_FRP_Base.monadDynamic));
    return function ($167) {
        return Final($166($167));
    };
})());
var heytingAlgebraFinal = function (dictHeytingAlgebra) {
    return new Data_HeytingAlgebra.HeytingAlgebra(Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.conj(dictHeytingAlgebra)), Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.disj(dictHeytingAlgebra)), Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.ff(dictHeytingAlgebra)), Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.implies(dictHeytingAlgebra)), Data_Functor.map(functorFinal)(Data_HeytingAlgebra.not(dictHeytingAlgebra)), Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.tt(dictHeytingAlgebra)));
};
var monadFinal = new Control_Monad.Monad(function () {
    return applicativeFinal;
}, function () {
    return bindFinal;
});
var monoidFinal = function (dictMonoid) {
    return new Data_Monoid.Monoid(function () {
        return semigroupFinal(dictMonoid.Semigroup0());
    }, Control_Applicative.pure(applicativeFinal)(Data_Monoid.mempty(dictMonoid)));
};
var anyPercentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $147 = x >= Data_Numeric.negate(Data_Numeric.additiveNumber)(100.0) && x <= 100.0;
            if ($147) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var additiveFinal = function (dictAdditive) {
    return new Data_Numeric.Additive(Control_Apply.lift2(applyFinal)(Data_Numeric.add(dictAdditive)), Control_Apply.lift2(applyFinal)(Data_Numeric.sub(dictAdditive)), Control_Applicative.pure(applicativeFinal)(Data_Numeric.zero(dictAdditive)));
};
module.exports = {
    FormField: FormField,
    Conversion: Conversion,
    newFormField: newFormField,
    newFormFieldE: newFormFieldE,
    newFormFieldEDyn: newFormFieldEDyn,
    fieldState: fieldState,
    fieldStateEmpty: fieldStateEmpty,
    focusFormState: focusFormState,
    noFieldState: noFieldState,
    editRef: editRef,
    isTouched: isTouched,
    focusOutCallback: focusOutCallback,
    formFieldValue: formFieldValue,
    displayedErrors: displayedErrors,
    finalValue: finalValue,
    Final: Final,
    makeFinal: makeFinal,
    liftMaybe: liftMaybe,
    unFinal: unFinal,
    invalidFinal: invalidFinal,
    finalValueNoErr: finalValueNoErr,
    liftDynamic: liftDynamic,
    stripPathPrefix: stripPathPrefix,
    atPath: atPath,
    maybeConversion: maybeConversion,
    nonEmptyArrayConversion: nonEmptyArrayConversion,
    moneyConversion: moneyConversion,
    nonNegativeMoneyConversion: nonNegativeMoneyConversion,
    positiveMoneyConversion: positiveMoneyConversion,
    intConversion: intConversion,
    nonNegativeIntConversion: nonNegativeIntConversion,
    positiveIntConversion: positiveIntConversion,
    rangeIntConversion: rangeIntConversion,
    numberConversion: numberConversion,
    nonNegativeNumberConversion: nonNegativeNumberConversion,
    positiveNumberConversion: positiveNumberConversion,
    anyPercentageConversion: anyPercentageConversion,
    percentageConversion: percentageConversion,
    intPercentageConversion: intPercentageConversion,
    emailConversion: emailConversion,
    maybeEmailConversion: maybeEmailConversion,
    phoneConversion: phoneConversion,
    maybePhoneConversion: maybePhoneConversion,
    maybeStringConversion: maybeStringConversion,
    nonEmptyStringConversion: nonEmptyStringConversion,
    emptyConversion: emptyConversion,
    nonNothingConversion: nonNothingConversion,
    functorFinal: functorFinal,
    heytingAlgebraFinal: heytingAlgebraFinal,
    applyFinal: applyFinal,
    applicativeFinal: applicativeFinal,
    bindFinal: bindFinal,
    monadFinal: monadFinal,
    semigroupFinal: semigroupFinal,
    monoidFinal: monoidFinal,
    additiveFinal: additiveFinal,
    hasFieldFinal: hasFieldFinal,
    semigroupoidConversion: semigroupoidConversion,
    categoryConversion: categoryConversion
};
//# sourceMappingURL=index.js.map
